(function (window, document) {
  'use strict';

  var root = document.querySelector('[data-shopify-compass]');
  var designMode = Boolean(window.Shopify && window.Shopify.designMode);
  if (!root && !designMode) return;
  if (document.documentElement.dataset.compassRuntime) return;

  var current = document.currentScript;
  if (!current || !current.src) return;

  document.documentElement.dataset.compassRuntime = 'loading';
  var script = document.createElement('script');
  script.src = current.src.replace(/compass\.js(?:\?.*)?$/, 'compass-runtime.js');
  script.defer = true;
  script.onload = function () {
    document.documentElement.dataset.compassRuntime = 'ready';
  };
  script.onerror = function () {
    document.documentElement.dataset.compassRuntime = 'error';
    var validation = document.querySelector('[data-compass-validation]');
    if (validation) {
      validation.hidden = false;
      validation.textContent = 'Der Bildungs-Kompass konnte nicht geladen werden. Bitte laden Sie die Seite neu oder kontaktieren Sie uns.';
    }
  };
  document.head.appendChild(script);
})(window, document);
